import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Používame súbory cookie',
    description:
      'Používame súbory cookie a podobné technológie na fungovanie tohto prostredia. Nevyhnutne potrebné súbory cookie sú vždy aktívne.',
    allow_label: 'Prijať všetky súbory cookie',
    reject_label: 'Iba nevyhnutne potrebné',
    settings_label: 'Nastavenia súborov cookie',
    policy_link_label: 'Zásady ochrany súkromia a súborov cookie',
    categories_label: 'Kategórie',
    always_on_label: 'Vždy aktívne',
    required_label: 'Povinné',
    save_preferences_label: 'Uložiť predvoľby',
    close_label: 'Zavrieť',
    allow_all_optional_categories_label: 'Povoliť všetky voliteľné kategórie',
    save_error: 'Vašu voľbu ochrany súkromia sa nepodarilo uložiť. Skúste to znova.'
  },
  categories: {
    strictly_necessary: {
      name: 'Nevyhnutne potrebné',
      purpose: 'Sú potrebné na fungovanie tohto prostredia a nemožno ich vypnúť.'
    },
    analytics: {
      name: 'Analytika',
      purpose: 'Merajú, ako návštevníci používajú toto prostredie, aby sa zlepšil výkon.'
    },
    marketing: { name: 'Marketing', purpose: 'Podporujú reklamu a marketing zvolené organizátorom.' }
  }
};

export default locale;
